var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompanySecondIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA6B1E3D-6951-4EC8-A68E-AA49F610D9D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "congratulate",
    transform: "translate(-165.000000, -172.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 11.9829787,
    cy: 1.0893617,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 4.35744681,
    cy: 4.35744681,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 19.6085106,
    cy: 4.35744681,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 19.6085106,
    cy: 19.6085106,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 4.35744681,
    cy: 19.6085106,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 11.9829787,
    cy: 22.8765957,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 1.0893617,
    cy: 11.9829787,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 22.8765957,
    cy: 11.9829787,
    r: 1.0893617
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9829787,3.26808511 C7.16987588,3.26808511 3.26808511,7.16987588 3.26808511,11.9829787 C3.26808511,16.7960816 7.16987588,20.6978723 11.9829787,20.6978723 C16.7960816,20.6978723 20.6978723,16.7960816 20.6978723,11.9829787 C20.6924692,7.1721157 16.7938417,3.27348821 11.9829787,3.26808511 Z M11.9829787,18.5191489 C8.37315159,18.5191489 5.44680851,15.5928059 5.44680851,11.9829787 C5.44680851,8.37315159 8.37315159,5.44680851 11.9829787,5.44680851 C15.5928059,5.44680851 18.5191489,8.37315159 18.5191489,11.9829787 C18.515546,15.5913124 15.5913124,18.515546 11.9829787,18.5191489 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompanySecondIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/companySecondIcon.8e1730a2991e6e37b5a628de665fc56c.svg";